namespace TabAurous.OMS {
    export interface PromotionDetailsRow {
        PromotionDetailsId?: number;
        PromoId?: number;
        PromoName?: string;
        CompanyName?: string;
        ProductTypeName?: string;
        CompanyId?: number;
        ProductTypeId?: number;
        PrdTypeId?: number;
        PromoCode?: string;
        ApplicableOn?: number;
        DiscountOn?: string;
        DiscountAmount?: number;
        DiscountPercentage?: number;
        FreeProductId?: number;
        MinimumSalesAmount?: number;
        CodeRequired?: boolean;
        MaximumRedeemCount?: number;
        FromDate?: string;
        ToDate?: string;
        IsDisabled?: boolean;
        IsApproved?: boolean;
    }

    export namespace PromotionDetailsRow {
        export const idProperty = 'PromotionDetailsId';
        export const localTextPrefix = 'OMS.PromotionDetails';
        export const deletePermission = 'Masters:Promotion:Delete';
        export const insertPermission = 'Masters:Promotion:Add';
        export const readPermission = '*';
        export const updatePermission = 'Masters:Promotion:Edit';

        export declare const enum Fields {
            PromotionDetailsId = "PromotionDetailsId",
            PromoId = "PromoId",
            PromoName = "PromoName",
            CompanyName = "CompanyName",
            ProductTypeName = "ProductTypeName",
            CompanyId = "CompanyId",
            ProductTypeId = "ProductTypeId",
            PrdTypeId = "PrdTypeId",
            PromoCode = "PromoCode",
            ApplicableOn = "ApplicableOn",
            DiscountOn = "DiscountOn",
            DiscountAmount = "DiscountAmount",
            DiscountPercentage = "DiscountPercentage",
            FreeProductId = "FreeProductId",
            MinimumSalesAmount = "MinimumSalesAmount",
            CodeRequired = "CodeRequired",
            MaximumRedeemCount = "MaximumRedeemCount",
            FromDate = "FromDate",
            ToDate = "ToDate",
            IsDisabled = "IsDisabled",
            IsApproved = "IsApproved"
        }
    }
}
